import { EvCarNoopEvents, NoopReasonCode, SearchEvCarNoopEventsCondition } from "@/models/carUnderuseEvents";
import { Office } from "@/models/office";
import { formatDateStr } from "@/util/datetime";

export const CarNoopReasonedEventsConstants = {
  CarNoopReasonedEvents: "未稼働理由登録履歴（日々の稼働確認）",
  CompanyOffice: "会社/営業所",
  RadioNumber: "無線番号",
  NoopStartDate: "未稼働初日",
  EventAt: "検出日時",
  NoopReason: "未稼働理由",
  RestartPlanDate: "稼働再開予定",
} as const;

export type SavedState = {
  officesSelected: Office[];
  page: number;
  searchCondition: SearchEvCarNoopEventsCondition;
};

export const PAGE_SIZE = 30;

// 事業者向けの一覧では、事故の2種類（事故報告フォーム未提出／提出済み）をまとめて「事故」と表示する
export const NOOP_REASON_LABELS: Record<NoopReasonCode, string> = {
  AccidentReportNotSubmitted: "事故",
  AccidentReportSubmitted: "事故",
  Failure: "事故ではない故障",
  Others: "事故や故障以外",
};

/**
 * 4営未稼働理由の enum 文字列を表示用の日本語に変換する.
 * 未設定（空文字）・想定外の値（null・対応表にない文字列）の場合は「-」を返す。
 */
export const getNoopReasonLabel = (noopReasonCode: NoopReasonCode | "" | null): string => {
  if (!noopReasonCode) {
    return "-";
  }
  return NOOP_REASON_LABELS[noopReasonCode] ?? "-";
};

export const getRestartPlanLabel = (event: EvCarNoopEvents): string => {
  if (event.falseDetection) {
    return "稼働している";
  }

  return event.restartPlanDate ? formatDateStr(event.restartPlanDate) : "";
};
